import React, { useState, useEffect } from 'react';
import Layout from '../../Component/Layout';
import axios from 'axios';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CharacteristicsModal from "../../Component/CharacteristicsModal ";
import { MASTER_API, PURCHASE_API } from "../../apiConfig";
import { hasPermission } from "../../utils/permission";
import { useNavigate, useLocation } from "react-router-dom";

const initialFormState = {
    productGroup: '', subgroup: '', productType: '', cableType: '', assetCategory: '', subCategory: '', division: '',
    referenceOfStandard: '', ISIMarked: '', voltage: '', construction: '', code: '', noOfCores: '', color: '', nominalCrossSection: '',
    assetCode: '', description: '', uom: '', baseUnit: '', weight: '', weightUom: '', referenceAssetCode: '', productClass: '', hsnCode: '', qualityCategory: '', productionClass: '', purchaseClass: '',

    itemCategory: '', sales_status: '', salesOrganization: '', distributionChannel: '', shippingFrom: '', pricePerKm: '',unitPrice: '',

    procurementType: '',
procurementLeadTime: { value: '', unit: '' },

moq: '',
moq_uom: '',

countryOfOrigin: '',
purchase_status: '',

lotSize: 'Lot to Lot',

productionLeadTime: { value: '', unit: '' },

MRP_status: '',
characteristics: [],
mrpPlanner: '',
mrpClass: '',

mpq: '',
mpq_uom: '',
    relevantForQuality: '', quality_status: '', storageType: '', logistics_status: '', productCost: '', currency: '', movingAveragePrice: '', accounting_status: '',

    material: '', nominalCrossSectionalArea: '', nominalCrossSectionalAreaUom: '', formOfConductor: '', minNumberOfStrands: '', minNumberOfStrandsUom: '', sizeBeforeBunching: '', sizeBeforeBunchingUom: '', maxDcResistanceAt20C: '', maxDcResistanceUom: '', thickness: '', thicknessUom: '', colourSchemeCores: '', colourInnerSheath: '', calculatedDiameter: '', calculatedDiameterUom: '', whetherExtruded: '',

    pgParameter1: '', pgParameter1Value: '', pgParameter2: '', pgParameter2Value: '', pgParameter3: '', pgParameter3Value: '', pgParameter4: '', pgParameter4Value: '', pgParameter5: '', pgParameter5Value: '', pgParameter6: '', pgParameter6Value: '', pgParameter7: '', pgParameter7Value: '', pgParameter8: '', pgParameter8Value: '', pgParameter9: '', pgParameter9Value: '', pgParameter10: '', pgParameter10Value: '',

    cccParameter1: '', cccParameter1Value: '', cccParameter1Uom: '', cccParameter2: '', cccParameter2Value: '', cccParameter2Uom: '', cccParameter3: '', cccParameter3Value: '', cccParameter3Uom: '', cccParameter4: '', cccParameter4Value: '', cccParameter4Uom: '', cccParameter5: '', cccParameter5Value: '', cccParameter5Uom: '', cccParameter6: '', cccParameter6Value: '', cccParameter6Uom: '', cccParameter7: '', cccParameter7Value: '', cccParameter7Uom: '', cccParameter8: '', cccParameter8Value: '', cccParameter8Uom: '', cccParameter9: '', cccParameter9Value: '', cccParameter9Uom: '', cccParameter10: '', cccParameter10Value: '', cccParameter10Uom: ''
};

function AssetMaster() {

    // const canView = hasPermission("ASSET_CODE", "view");
    const canCreate = hasPermission("ASSET_CODE", "create");
    const canEdit = hasPermission("ASSET_CODE", "edit");
    // const canApprove = hasPermission("ASSET_CODE", "approve");

    const [masterData, setMasterData] = useState({
        groups: [], types: [], brands: [], categories: [], assetCategories: [],
        assetCodes: [], hsnCodes: [], salesOrgs: [], subCategories: [], qualityCategories: [],
        // NEW DB DROPDOWNS
        uoms: [], statuses: [], currencies: [], procTypes: [],
        nominalCrossSections: [],
        referenceOdStandards: [],
        voltages: [],
        distChannels: [], lotSizes: [], countries: [], specialProcs: [], productClasses: []
    });
    const [products, setProducts] = useState([]);
    const [productLogs, setProductLogs] = useState([]);
    const [formData, setFormData] = useState(initialFormState);
const [originalProduct, setOriginalProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState('create');
    const [activeTab, setActiveTab] = useState("basic");
    const [totalPages, setTotalPages] = useState(1);
    const [totalProducts, setTotalProducts] = useState(0);


    const [filters, setFilters] = useState({
        group: null,
        type: null,
        brand: null,


        construction: null,
        code: '',
        productType: null,
        cableType: null,
        category: null,
        referenceOfStandard: null,

        subCategory: null,
        qualityCategory: null,
        color: '',
        cores: null,
        crossSection: null,
        voltage: null,
        description: '',

        assetCode: ''
    });

    // cascading filter options derived from real product data, keyed by field name
    const [filterOptions, setFilterOptions] = useState({
        category: [], cableType: [], code: [], color: [], noOfCores: [],
        nominalCrossSection: [], referenceOfStandard: [], voltage: [], construction: [],
        subCategory: [], qualityCategory: []
    });

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showReplaceConfirm, setShowReplaceConfirm] = useState(false);
    const [deletedConflictCodes, setDeletedConflictCodes] = useState([]);
    const [showDeleteDraftConfirm, setShowDeleteDraftConfirm] = useState(false);
    const [draftToDelete, setDraftToDelete] = useState(null);
    const [showDraftReplaceConfirm, setShowDraftReplaceConfirm] = useState(false);
    const [draftReplaceTarget, setDraftReplaceTarget] = useState(null);
    const [showBulkReplaceConfirm, setShowBulkReplaceConfirm] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showDraftModal, setShowDraftModal] = useState(false);
    const [draftsList, setDraftsList] = useState([]);
    const [isPublishingAll, setIsPublishingAll] = useState(false);
    const [publishingId, setPublishingId] = useState(null);
    const [isDraftView, setIsDraftView] = useState(false);
    //eslint-disable-next-line
    const [pgCount, setPgCount] = useState(1);
    //eslint-disable-next-line
    const [cccCount, setCccCount] = useState(1);
    // const [showProductClassView, setShowProductClassView] = useState(false);
    // const [selectedProductClass, setSelectedProductClass] = useState(null);
    const [showConfigViewModal, setShowConfigViewModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    //eslint-disable-next-line
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [showMrpCharModal, setShowMrpCharModal] = useState(false);
    //eslint-disable-next-line
    const [mrpCharLineItemId, setMrpCharLineItemId] = useState(null);
    const [mrpCharacteristics, setMrpCharacteristics] = useState([]);
    const [mrpCharLoading, setMrpCharLoading] = useState(false);
    const [codeDescList, setCodeDescList] = useState([]);

    const navigate = useNavigate();
    const location = useLocation(); // Add this line


    const handleUpdateExcel = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await axios.post(
                `${PURCHASE_API}/asset-master/update-price-per-km`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const errors = res?.data?.errors || [];

            if (errors.length > 0) {
                toast.warning(`${res.data.message} (${errors.length} rows failed)`);
            } else {
                toast.success(res.data.message);
            }

            await fetchProducts(); // ✅ now works
            setShowUpdateModal(false);

        } catch (err) {
            console.error("REAL ERROR:", err);
            if (!err.response) {
                toast.error("Update failed");
            }
        }
    };
    const customSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: 32,
            height: 32,
            fontSize: '13px',
            borderColor: '#dee2e6',
            boxShadow: 'none',
            '&:hover': { borderColor: '#b3b3b3' }
        }),
        valueContainer: (base) => ({ ...base, padding: '0 8px', height: '32px', display: 'flex', alignItems: 'center' }),
        input: (base) => ({ ...base, margin: 0, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 4 }),
        menu: (base) => ({ ...base, fontSize: '13px', zIndex: 9999 }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // 👈 ADD THIS LINE
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#1e293b' : state.isFocused ? '#f1f5f9' : 'white',
            color: state.isSelected ? 'white' : '#334155',
            cursor: 'pointer',
            fontSize: '13px'
        })
    };
    const activeInactiveOptions = [
        "Active",
        "Inactive"
    ];
    const fetchFilterOptions = async () => {
        try {
            const res = await axios.get(
                `${PURCHASE_API}/asset-master/filter-options`,
                {
                    params: {
                        productType: filters.productType?.value || "",
                        category: filters.category?.value || "",
                        cableType: filters.cableType?.value || "",
                        code: filters.code || "",
                        color: filters.color || "",
                        noOfCores: filters.cores?.value || "",
                        nominalCrossSection: filters.crossSection?.value || "",
                        referenceOfStandard: filters.referenceOfStandard?.value || "",
                        voltage: filters.voltage?.value || "",
                        subCategory: filters.subCategory?.value || ""
                    }
                }
            );
            setFilterOptions(prev => ({ ...prev, ...res.data }));
        } catch (e) {
            console.error("Failed to fetch filter options", e);
        }
    };

    useEffect(() => {
        fetchFilterOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters.productType,
        filters.category,
        filters.cableType,
        filters.code,
        filters.color,
        filters.cores,
        filters.crossSection,
        filters.referenceOfStandard,
        filters.voltage,
        filters.subCategory
    ]);

    const toStrOptions = (arr) => (arr || []).map(v => ({ value: v, label: v }));

    // masterData lists from /configuration/* come back as [{id, name}], whereas
    // renderCascadeSelect expects a flat array of plain values. This normalizes either shape.
    const namesOf = (arr) => (arr || []).map(v => (v && typeof v === 'object' ? v.name : v));

    // renderSelect variant for the fields in the create/edit/view modal.
    // Same look as renderSelect. Each field is fully independent now -
    // picking a value only ever updates its own field, it never clears
    // or otherwise affects any other field.
    const renderCascadeSelect = (label, name, optionsArr, colClass) => {
        const mappedOptions = toStrOptions(optionsArr);

        const selectedOption = mappedOptions.find(o =>
            String(o.value).trim().toLowerCase() === String(formData[name] || '').trim().toLowerCase()
        ) || null;

        const boldLabels = [
            "Construction", "Code", "Product Type", "Cable Type", "Category",
            "No of Cores", "Color", "Nominal Cross Section", "Whether ISI Marked",
            "Ref of Standard", "Voltage", "Sub Category", "Quality Category"
        ];

        return (
            <div className={colClass}>
                <label
                    style={{
                        ...styles.compactLabel,
                        fontWeight: boldLabels.includes(label?.trim()) ? "700" : "400"
                    }}
                >
                    {label}
                </label>
                <Select
                    styles={customSelectStyles}
                    options={mappedOptions}
                    value={selectedOption}
                    onChange={v => {
                        setFormData(prev => ({ ...prev, [name]: v ? v.value : '' }));
                    }}
                    isDisabled={modalMode === 'view'}
                    placeholder="Select"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    maxMenuHeight={250}
                    menuShouldScrollIntoView={false}
                    closeMenuOnSelect={true}
                />
            </div>
        );
    };

    const fetchProducts = async () => {

        try {

            const res = await axios.get(
                `${PURCHASE_API}/asset-master/products`,
                {
                    params: {

                        page: currentPage,

                        limit: itemsPerPage,

                        construction:
                            filters.construction?.value || "",

                        code:
                            filters.code || "",

                        productType:
                            filters.productType?.value || "",

                        cableType:
                            filters.cableType?.value || "",

                        assetCategory:
                            filters.category?.value || "",

                        referenceOfStandard:
                            filters.referenceOfStandard?.value || "",

                        subCategory:
                            filters.subCategory?.value || "",

                        qualityCategory:
                            filters.qualityCategory?.value || "",

                        color:
                            filters.color || "",

                        noOfCores:
                            filters.cores?.value || "",

                        nominalCrossSection:
                            filters.crossSection?.value || "",

                        voltage:
                            filters.voltage?.value || "",

                        description:
                            filters.description || "",

                        assetCode:
                            filters.assetCode || ""
                    }
                }
            );

            setProducts(res.data.data);

            setTotalProducts(res.data.total || 0);

            setTotalPages(
                Math.ceil(
                    res.data.total / itemsPerPage
                )
            );

        } catch (e) {

            console.error(
                "Failed to fetch products"
            );
        }
    };

    const handleDeleteProduct = (assetCode) => {
        setProductToDelete(assetCode);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteProduct = async () => {

        const assetCode = productToDelete;
        setShowDeleteConfirm(false);

        if (!assetCode) return;

        try {
            await axios.delete(
                `${PURCHASE_API}/asset-master/products/${encodeURIComponent(assetCode)}`
            );

            toast.success("Asset deleted successfully");

            // remove from UI immediately, DB keeps it with status = 'deleted'
            setProducts(prev => prev.filter(p => p.assetCode !== assetCode));
            setTotalProducts(prev => Math.max(0, prev - 1));

        } catch (e) {
            console.error("Failed to delete product", e);
            toast.error("Failed to delete product");
        } finally {
            setProductToDelete(null);
        }
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const viewAssetCode = queryParams.get("view");
        const resume = queryParams.get("resume");
        const resumeView = queryParams.get("resumeView");


        if (resumeView && !isModalOpen) {

    const saved = sessionStorage.getItem("productViewResumeState");

    if (saved) {

        try {

            const state = JSON.parse(saved);

            setFormData(state.formData);

            setProductLogs(state.productLogs || []);

            setModalMode("view");

            setActiveTab(state.activeTab || "basic");

            setPgCount(state.pgCount || 1);

            setCccCount(state.cccCount || 1);

            setIsDraftView(false);

            setIsModalOpen(true);

        } catch (e) {

            console.error(e);

        }

    }

    sessionStorage.removeItem("productViewResumeState");

    navigate("/cable/product/product-code", {
        replace: true
    });

    return;
}

        // Automatically open the modal if the URL tells us to
        if (viewAssetCode && !isModalOpen) {
            openViewModal(viewAssetCode);
        } else if (resume && !isModalOpen) {
            // Coming back from Product Configuration while we were in the
            // middle of creating/editing a product (not saved yet, so it
            // can't be re-fetched from the server) — restore the draft we
            // stashed before navigating away.
            const saved = sessionStorage.getItem("productModalResumeState");

            if (saved) {
                try {
                    const state = JSON.parse(saved);
                    setFormData(state.formData);
                    setModalMode(state.modalMode || "create");
                    setActiveTab(state.activeTab || "basic");
                    if (state.pgCount) setPgCount(state.pgCount);
                    if (state.cccCount) setCccCount(state.cccCount);
                    setIsModalOpen(true);
                } catch (e) {
                    console.error("Failed to restore product draft", e);
                }
            }

            sessionStorage.removeItem("productModalResumeState");
            // Clean the URL so a refresh doesn't try to resume again
            navigate("/cable/product/product-code", { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    useEffect(() => {

        fetchProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage,
        filters
    ]);

    useEffect(() => {

        const loadCodeDescList = async () => {
        try {
            const res = await axios.get(
                `${PURCHASE_API}/asset-master/assetCodeDescriptionList`,
                {
                    params: {
                        productType: filters.productType?.value || ""
                    }
                }
            );
            setCodeDescList(res.data || []);
        } catch (e) {
            console.error("Failed to load product code/description list");
        }
    };

    loadCodeDescList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.productType]);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [
                    typ,
                    cableType,
                    cat,
                    subCat,
                    construction,
                    core,
                    colour,
                    code,
                    pcodes,
                    hsn,
                    uom,
                    curr,
                    proc,
                    lotSize,
                    country,
                    pclass,
                    salesOrganizations,
                    shippingFroms,
                    distributionChannels,
                    mrpPlanners,
                    nominalCrossSections,
                    referenceOdStandards,
                    voltages,
                    qualityCat,
                    assetCat
                ] = await Promise.all([
                    axios.get(`${MASTER_API}/configuration/product-types`),

                    axios.get(`${MASTER_API}/configuration/cable-type`),

                    axios.get(`${MASTER_API}/configuration/category`),

                    axios.get(`${MASTER_API}/configuration/sub-category`),

                    axios.get(`${MASTER_API}/configuration/construction`),

                    axios.get(`${MASTER_API}/configuration/core`),

                    axios.get(`${MASTER_API}/configuration/colour`),

                    axios.get(`${MASTER_API}/configuration/dynamic/code`),

                    axios.get(`${PURCHASE_API}/asset-master/master/assetCode`),

                    axios.get(`${MASTER_API}/configuration/hsn-code`),

                    axios.get(`${PURCHASE_API}/asset-master/uom_list`),

                    axios.get(`${MASTER_API}/configuration/currency`),

                    axios.get(`${PURCHASE_API}/asset-master/master/procurementType`),

                    axios.get(`${PURCHASE_API}/asset-master/master/lotSize`),

                    axios.get(`${PURCHASE_API}/asset-master/country_master`),

                    axios.get(`${PURCHASE_API}/asset-master/class_code`),

                    axios.get(`${MASTER_API}/configuration/dynamic/sales-organization`),

                    axios.get(`${MASTER_API}/configuration/dynamic/shipping-from`),

                    axios.get(`${MASTER_API}/configuration/dynamic/distribution-channel`),

                    axios.get(`${MASTER_API}/configuration/dynamic/mrp-planner`),

                    axios.get(`${MASTER_API}/configuration/dynamic/nominal-cross-section`),

                    axios.get(`${MASTER_API}/configuration/dynamic/reference-of-standard`),

                    axios.get(`${MASTER_API}/configuration/dynamic/voltage`),
                    axios.get(`${MASTER_API}/configuration/quality-category`),
                    axios.get(`${MASTER_API}/configuration/dynamic/asset-category`)
                ]);

                setMasterData({
                    productClasses: pclass.data,

                    salesOrganizations: salesOrganizations.data,
                    codes: code.data,

                    shippingFroms: shippingFroms.data,

                    distributionChannels: distributionChannels.data,

                    mrpPlanners: mrpPlanners.data,

                    types: typ.data,
                    cableTypes: cableType.data,
                    categories: cat.data,
                    assetCategories: assetCat.data,
                    subCategories: subCat.data,
                    qualityCategories: qualityCat.data,

                    constructions: construction.data,
                    cores: core.data,
                    colours: colour.data,

                    // classes: cls.data,
                    // locations: loc.data,
                    assetCodes: pcodes.data,
                    hsnCodes: hsn.data,
                    nominalCrossSections: nominalCrossSections.data,
                    referenceOdStandards: referenceOdStandards.data,
                    voltages: voltages.data,

                    uoms: uom.data,
                    statuses: activeInactiveOptions,
                    currencies: curr.data,
                    procTypes: proc.data,

                    lotSizes: [
                        "Daily",
                        "Weekly",
                        "Lot to Lot"
                    ],

                    countries: country.data
                });

            } catch (err) { console.error(err); toast.error("Failed to load data"); }
        };
        fetchAll();
        loadDrafts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);






    const getOptions = (list, isDb = true) => {

        if (!list) return [];

        return list.map(i => {

            // if already string
            if (typeof i === "string") {
                return {
                    value: i,
                    label: i
                };
            }

            // DB object mapping
            const val =
                i.name ||
                i.currency ||
                i.currency_name ||
                i.category_name ||
                i.quality_category_name ||
                i.category ||
                i.code ||
                i.core ||
                i.cable_type ||
                i.class_code ||
                i.uom_name ||
                i.uom ||
                i.hsn_code ||
                i.deliveryLocation ||
                i.location ||
                i.country_name ||
                i.country ||
                i.country_code ||
                "";

            return {
                value: String(val).trim(),
                label: String(val).trim()
            };
        });
    };
    // ==========================================
    // 🌟 BULK UPLOAD & DRAFT LOGIC
    // ==========================================
    const loadDrafts = async () => {
        try {
            const res = await axios.get(
                `${PURCHASE_API}/asset-master/get-drafts`
            );

            if (res.data.success) {

                setDraftsList(
                    res.data.drafts || []
                );

                // Always resync from the DB — this is what makes the
                // "already deleted" dialog show up reliably even after
                // a page reload, not just right after an Excel upload.
                setDeletedConflictCodes(
                    res.data.deletedConflicts || []
                );
            }

        } catch (err) {

            console.error(
                "Failed to load drafts",
                err
            );

        }
    };

    const handleBulkExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const uploadData = new FormData();
        uploadData.append("file", file);

        try {
            const res = await axios.post(`${PURCHASE_API}/asset-master/parse-excel`, uploadData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.success) {
                toast.success(res.data.message);

                if (res.data.deletedConflicts?.length > 0) {
                    setDeletedConflictCodes(res.data.deletedConflicts);
                    toast.info(
                        `${res.data.deletedConflicts.length} product(s) match previously deleted entries. ` +
                        `You'll be asked to confirm when publishing them.`
                    );
                }

                loadDrafts();
                setShowUploadModal(false);
                setShowDraftModal(true);
            } else {
                toast.info(res.data.message);
            }
        } catch (err) {
            toast.error(err.response?.data?.error || "Failed to upload Excel file");
        } finally {
            e.target.value = null;
        }
    };

    const handlePublishDraft = async (assetCode, replaceExisting = false) => {

        setPublishingId(assetCode);

        try {

            const res = await axios.post(
                `${PURCHASE_API}/asset-master/publish-draft`,
                { assetCode, replaceExisting }
            );

            if (res.data.success) {

                toast.success(res.data.message);

                setDeletedConflictCodes(prev => prev.filter(c => c !== assetCode));

                await loadDrafts();

                return;
            }

        } catch (err) {

            console.log(
                "FRONTEND ERROR =",
                err.response?.data || err
            );

            toast.error(
                "Failed to publish draft"
            );

        } finally {

            setPublishingId(null);
        }
    };

    const onClickPublishDraft = (assetCode) => {
        if (deletedConflictCodes.includes(assetCode)) {
            setDraftReplaceTarget(assetCode);
            setShowDraftReplaceConfirm(true);
        } else {
            handlePublishDraft(assetCode, false);
        }
    };

    const handleDeleteDraft = (assetCode) => {
        setDraftToDelete(assetCode);
        setShowDeleteDraftConfirm(true);
    };

    const confirmDeleteDraft = async () => {

        const assetCode = draftToDelete;
        setShowDeleteDraftConfirm(false);

        if (!assetCode) return;

        try {
            await axios.delete(
                `${PURCHASE_API}/asset-master/drafts/${encodeURIComponent(assetCode)}`
            );

            toast.success("Draft deleted successfully");

            setDraftsList(prev => prev.filter(d => d.assetCode !== assetCode));
            setDeletedConflictCodes(prev => prev.filter(c => c !== assetCode));

        } catch (e) {
            console.error("Failed to delete draft", e);
            toast.error("Failed to delete draft");
        } finally {
            setDraftToDelete(null);
        }
    };

    const publishAllDraftsApi = async (replaceExisting) => {
        setIsPublishingAll(true);
        try {
            const res = await axios.post(
                `${PURCHASE_API}/asset-master/publish-all-drafts`,
                { replaceExisting }
            );
            if (res.data.success) {
                toast.success(res.data.message);
                setDeletedConflictCodes([]); // all handled now
                loadDrafts();
                fetchProducts();
                setShowDraftModal(false);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Error saving drafts");
        } finally {
            setIsPublishingAll(false);
        }
    };

    const handlePublishAllDrafts = () => {
        if (draftsList.length === 0) return;

        const conflictsInList = draftsList
            .map(d => d.assetCode)
            .filter(code => deletedConflictCodes.includes(code));

        if (conflictsInList.length > 0) {
            setShowBulkReplaceConfirm(true);
            return;
        }

        publishAllDraftsApi(false);
    };

    const openDraftView = (draft) => {

        let maxPg = 1,
            maxCcc = 1;

        for (let i = 10; i >= 1; i--) {
            if (draft[`pgParameter${i}`]) {
                maxPg = i;
                break;
            }
        }

        for (let i = 10; i >= 1; i--) {
            if (draft[`cccParameter${i}`]) {
                maxCcc = i;
                break;
            }
        }

        setPgCount(maxPg);
        setCccCount(maxCcc);

        const mappedData = {
            ...initialFormState,
            ...draft,

            baseUnit:
                draft.baseUnit || "",

            procurementLeadTime: {
                value: draft.procurementLeadTime
                    ? String(draft.procurementLeadTime)
                    : "",

                unit: draft.procurementLeadTimeUom
                    ? String(draft.procurementLeadTimeUom)
                    : ""
            },

            productionLeadTime: {
                value: draft.productionLeadTime
                    ? String(draft.productionLeadTime)
                    : "",

                unit: draft.productionLeadTimeUom
                    ? String(draft.productionLeadTimeUom)
                    : ""
            },

            weight: draft.weight
                ? String(draft.weight)
                : "",

            weightUom: draft.weightUom
                ? String(draft.weightUom)
                : "",

            characteristics: draft.characteristics
                ? (
                    typeof draft.characteristics === "string"
                        ? JSON.parse(draft.characteristics)
                        : draft.characteristics
                )
                : []
        };

        setFormData(mappedData);

        setModalMode("view_draft");

        setIsDraftView(true);

        setShowDraftModal(false);

        setIsModalOpen(true);

        setActiveTab("basic");
    };

    const handleAddProduct = () => {
        setFormData(initialFormState);
        setPgCount(1);
        setCccCount(1);
        setModalMode('create');
        setIsDraftView(false);
        setIsModalOpen(true);
        setActiveTab('basic');
    };

const openViewModal = async (pCode) => {
    try {
        // 🔹 1. Fetch product details
        const res = await axios.get(
            `${PURCHASE_API}/asset-master/assetdetails/${pCode}`
        );

        // 🔹 2. Fetch change logs (ADD THIS)
        try {
            const logRes = await axios.get(
                `${PURCHASE_API}/asset-master/change-logs/${pCode}`
            );


            setProductLogs(logRes.data);           // ✅ store logs
        } catch (err) {
            console.error("Log fetch error:", err);
        }

        const data = res.data;

        let savedChars = [];
        if (data.characteristics) {
            savedChars =
                typeof data.characteristics === 'string'
                    ? JSON.parse(data.characteristics)
                    : data.characteristics;
        }

        let maxPg = 1, maxCcc = 1;
        for (let i = 10; i >= 1; i--) {
            if (data[`pgParameter${i}`]) {
                maxPg = i;
                break;
            }
        }
        for (let i = 10; i >= 1; i--) {
            if (data[`cccParameter${i}`]) {
                maxCcc = i;
                break;
            }
        }

        setPgCount(maxPg);
        setCccCount(maxCcc);

        const viewFormData = {
            ...data,
            moq: data.moq || "",
            description:
                data.assetDescription || "",
            voltage:
                data.voltage || "",
            procurementType: data.procurementType || '',
            moq: data.moq || "",
moq_uom: data.moq_uom || "",

mpq: data.mpq || "",
mpq_uom: data.mpq_uom || "",

            baseUnit: data.baseUnit || '',
            procurementLeadTime: {
                value: data.procurementLeadTime
                    ? String(data.procurementLeadTime)
                    : "",

                unit: data.procurementLeadTimeUom
                    ? String(data.procurementLeadTimeUom)
                    : ""
            },
            productionLeadTime: {
                value: data.productionLeadTime
                    ? String(data.productionLeadTime)
                    : "",

                unit: data.productionLeadTimeUom
                    ? String(data.productionLeadTimeUom)
                    : ""
            },

            weight: data.weight
                ? String(data.weight)
                : "",

            weightUom: data.weightUom
                ? String(data.weightUom)
                : "", characteristics: savedChars
        };

        setFormData(viewFormData);
        setOriginalProduct(viewFormData);

        setModalMode('view');
        setIsDraftView(false);
        setActiveTab('basic');
        setIsModalOpen(true);

    } catch (e) {
        toast.error("Failed to fetch details");
    }
};
    const closeModal = () => {
        setIsModalOpen(false);
        if (isDraftView) {
            setShowDraftModal(true);
            setIsDraftView(false);
        }

        // Handle navigation back to the previous screen
        const queryParams = new URLSearchParams(location.search);
        const returnTo = queryParams.get("returnTo");

        if (returnTo) {
            navigate(returnTo, { replace: true });
        } else if (queryParams.get("view")) {
            // If there's no returnTo, clean the URL parameters to match your actual route
            navigate("/cable/product/product-code", { replace: true });
        }
    };

   const handleSave = async (forceReplace = false, skipDuplicateCheck = false) => {
    if (!formData.assetCode) return toast.warning("Asset Code is required");

    if (modalMode === 'create' && !forceReplace && !skipDuplicateCheck) {
        try {
            const check = await axios.get(
                `${PURCHASE_API}/asset-master/checkAssetCode?assetCode=${formData.assetCode}`
            );

            if (check.data.exists) {
                if (check.data.isDeleted) {
                    setShowReplaceConfirm(true);
                    return;
                }
                return toast.error("Asset Code already exists");
            }

        } catch (e) {
            console.error(e);
            return toast.error("Failed to validate Product Code");
        }
    }
    // Determine which endpoint to hit based on the mode
    let endpoint = 'saveProductDetails';
    let method = 'post';

    if (modalMode === 'edit') {
        endpoint = 'update-product-details';
        method = 'put';
    }
    else if (modalMode === 'edit_draft') {
        endpoint = 'update-draft-details';
        method = 'put';
    }
    else {
        endpoint = 'saveProductDetails';
        method = 'post';
    }

    let payload = {};

    if (modalMode === "edit") {

        payload = {
            assetCode: formData.assetCode
        };

        Object.keys(formData).forEach((key) => {

            if (
                formData[key] !== originalProduct?.[key]
            ) {
                payload[key] = formData[key];
            }
        });

    } else {

        payload = {
            ...formData
        };
    }

    payload = {
        ...payload,

        moq: payload.moq,

        procurementType: payload.procurementType,
        countryOfOrigin: payload.countryOfOrigin,

        procurementLeadTime:
            payload.procurementLeadTime?.value || "",

        procurementLeadTimeUom:
            payload.procurementLeadTime?.unit || "",

        purchase_status:
            payload.purchase_status,

        productionLeadTime:
            payload.productionLeadTime?.value || "",

        productionLeadTimeUom:
            payload.productionLeadTime?.unit || "",

        lotSize:
            payload.lotSize,

        MRP_status:
            payload.MRP_status,

        relevantForQuality:
            payload.relevantForQuality,

        quality_status:
            payload.quality_status,

        storageType:
            payload.storageType,

        logistics_status:
            payload.logistics_status,

        productCost:
            payload.productCost,

        currency:
            payload.currency,

        pricePerKm:
            payload.pricePerKm,

            unitPrice: payload.unitPrice,

        movingAveragePrice:
            payload.movingAveragePrice,

        accounting_status:
            payload.accounting_status,

        weightUom:
            payload.weightUom || "",

        assetDescription:
            payload.description,
            moq: payload.moq,
moq_uom: payload.moq_uom,

mpq: payload.mpq,
mpq_uom: payload.mpq_uom,

        voltage:
            payload.voltage,

        characteristics:
            payload.characteristics || [],

        replaceExisting: forceReplace
    };
    try {
        await axios[method](
            `${PURCHASE_API}/asset-master/${endpoint}`,
            payload
        );

        toast.success("Success!");

        if (modalMode === 'edit_draft') {
            loadDrafts(); // Refresh the draft list
            setShowDraftModal(true); // Re-open the draft list modal
        } else {
            fetchProducts(); // Refresh main product list
        }
        setIsModalOpen(false);
    } catch (e) {
        toast.error("Failed to save");
    }
};

    const handleOpenMrpCharModal = async () => {

        if (!formData.assetCode) {
            return toast.warning("Asset code not found");
        }

        setMrpCharLoading(true);

        try {

            // 1. Get template (characteristic names from mrpClass config) + lineItemId
            const templateRes = await axios.get(
                `${PURCHASE_API}/asset-master/mrp-characteristics/template?assetCode=${formData.assetCode}`
            );

            const { lineItemId, characteristics: templateChars } = templateRes.data;

            setMrpCharLineItemId(lineItemId);

            if (!lineItemId) {
                toast.warning("Asset not saved yet. Save the asset first.");
                setMrpCharLoading(false);
                return;
            }
            // 2. Get any previously saved values (prefer local unsaved edits over DB)
            let savedChars = [];
            if (formData.characteristics && formData.characteristics.length > 0) {
                savedChars = formData.characteristics; // Use local unsaved edits!
            } else if (lineItemId) {
                const savedRes = await axios.get(
                    `${PURCHASE_API}/asset-master/mrp-characteristics?assetCode=${formData.assetCode}&lineItemId=${lineItemId}`
                );
                savedChars = savedRes.data?.characteristics || [];
            }

            // 3. Merge: use template as base, overlay saved values
            const merged = templateChars.map(t => {
                const saved = savedChars.find(
                    s => s.characteristic === t.characteristic
                );
                return {
                    characteristic: t.characteristic,
                    value: saved ? (saved.value || "") : ""
                };
            });

            // 4. If no template chars but we have saved chars, show saved ones
            const finalChars = merged.length > 0 ? merged : savedChars;

            setMrpCharacteristics(finalChars);
            setShowMrpCharModal(true);

        } catch (err) {
            console.error("handleOpenMrpCharModal error:", err);
            toast.error("Failed to load characteristics");
        } finally {
            setMrpCharLoading(false);
        }
    };

    const handleSaveMrpCharModal = async (newChars) => {
        if (modalMode === 'view') {
            setShowMrpCharModal(false);
            return;
        }
        setMrpCharacteristics(newChars);
        setFormData(prev => ({
            ...prev,
            characteristics: newChars
        }));
        setShowMrpCharModal(false);
    };

    const renderSelect = (label, name, options, colClass = "col-md-6", isDb = true) => {
        const mappedOptions = getOptions(options, isDb);

        // 🌟 FIXED: Case-insensitive and space-trimmed matching!
        const selectedOption = mappedOptions.find(o =>
            String(o.value).trim().toLowerCase() === String(formData[name] || '').trim().toLowerCase()
        ) || null;



        return (
            <div className={colClass}>

                <label
                    style={{
                        ...styles.compactLabel,
                        fontWeight: [
                            "Construction",
                            "Code",
                            "Product Type",
                            "Cable Type",
                            "Category",
                            "No of Cores",
                            "Color",
                            "Nominal Cross Section",
                            "Whether ISI Marked",
                            "Ref of Standard",
                            "Voltage",
                            "Sub Category",
                            "Quality Category"
                        ].includes(label?.trim())
                            ? "700"
                            : "400"
                    }}
                >
                    {label}
                </label>

                <Select
                    styles={customSelectStyles}

                    options={mappedOptions || []}

                    value={selectedOption}

                    onChange={v =>
                        setFormData(prev => ({
                            ...prev,
                            [name]: v ? v.value : ''
                        }))
                    }

                    isDisabled={modalMode === 'view'}

                    placeholder="Select"

                    isClearable

                    menuPortalTarget={document.body}

                    menuPosition="fixed"

                    menuPlacement="auto"

                    maxMenuHeight={250}

                    menuShouldScrollIntoView={false}

                    closeMenuOnSelect={true}
                />

            </div>
        );
    };


    const filteredProductClasses = [
        ...new Map(
            (masterData.productClasses || [])
                .filter(
                    item =>
                        String(item.class_type || "")
                            .trim()
                            .toLowerCase() ===
                        "sales class"
                )
                .map(item => [
                    item.class_code,
                    {
                        class_code: item.class_code
                    }
                ])
        ).values()
    ];
    const filteredMrpClasses = [
        ...new Map(
            (masterData.productClasses || [])
                .filter(
                    item =>
                        String(item.class_type || "")
                            .trim()
                            .toLowerCase() === "mrp class"
                )
                .map(item => [
                    item.class_code,
                    {
                        class_code: item.class_code
                    }
                ])
        ).values()
    ];

    const allProductClasses = [
        ...new Map(
            (masterData.productClasses || [])
                .map(item => [
                    item.class_code,
                    {
                        class_code: item.class_code
                    }
                ])
        ).values()
    ];

    const renderInput = (label, name, type = "text", colClass = "col-md-6", customDisabled = false) => (
        <div className={colClass}>
            <label
                style={{
                    ...styles.compactLabel,
                    fontWeight: [
                        "Construction",
                        "Code",
                        "Product Type",
                        "Cable Type",
                        "Category",
                        "No of Cores",
                        "Color",
                        "Nominal Cross Section",
                        "Whether ISI Marked",
                        "Ref of Standard",
                        "Voltage",
                        "Sub Category",
                        "Quality Category"
                    ].includes(label?.trim())
                        ? "700"
                        : "400"
                }}
            >
                {label}
            </label>
            <input
                type={type}
                className="form-control"
                style={styles.compactInput}
                name={name}
                value={formData[name] || ''}
                onChange={e => setFormData(prev => ({ ...prev, [name]: e.target.value }))}
                disabled={modalMode === 'view' || customDisabled}
            />
        </div>
    );

    return (
        <Layout>
            <div style={styles.pageTitleBar}>
                <div>
                    <h2 style={styles.pageTitle}>Asset Master</h2>
                    <p style={styles.pageSubtitle}>Manage your product master catalog</p>
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>

                        {(() => {
                            const equalBtnStyle = {
                                width: "220px",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "6px",
                                fontWeight: 600,
                                borderRadius: "6px",
                                whiteSpace: "nowrap",

                                background: "#021843",
                                color: "#fff",
                                border: "1px solid #021843",

                                outline: "none",
                                boxShadow: "none",

                                appearance: "none",
                                WebkitAppearance: "none",
                                MozAppearance: "none",

                                cursor: "pointer",
                                transition: "none"
                            };

                            return (
                                <>
                                    {/* CREATE BUTTON */}
                                    <button

                                        style={{ ...equalBtnStyle, width: "200px" }}
                                        onClick={() => {
                                            if (!canCreate) {
                                                toast.error("You don't have Create access. Please contact admin.");
                                                return;
                                            }

                                            handleAddProduct();
                                        }}
                                    >
                                        + Create 
                                    </button>
                                </>
                            );
                        })()}

                    </div>
                </div>
                
            </div>
            {(() => {

                const selectedType = (filters.productType?.value || "").trim().toLowerCase();
                const isRawMaterial = selectedType === "raw material";
                const isFinishedLike = selectedType && !isRawMaterial;

                const updateFilter = (patch) => {
                    setCurrentPage(1);
                    setFilters({ ...filters, ...patch });
                };

                const activeFilterCount = [
                    filters.productType,
                    filters.category,
                    filters.assetCode,
                    filters.description
                ].filter(v => v !== null && v !== '' && v !== undefined).length;

                const clearAll = () => {
                    setCurrentPage(1);
                    setFilters({
                        ...filters,
                        productType: null,
                        cableType: null,
                        category: null,
                        referenceOfStandard: null,
                        construction: null,
                        cores: null,
                        crossSection: null,
                        voltage: null,
                        color: '',
                        subCategory: null,
                        qualityCategory: null,
                        code: '',
                        assetCode: '',
                        description: ''
                    });
                };

                const fieldBox = { minWidth: 105, flex: "1 1 105px" };

                return (
                    <div style={styles.filterCard}>

                        {/* PRODUCT TYPE + CLEAR ALL */}
                        <div style={{ display: "flex", alignItems: "flex-end", gap: 12 }}>
                            <div style={{ minWidth: 220 }}>
                                <label style={styles.compactLabel}>Product Type</label>
                                <Select
                                    styles={customSelectStyles}
                                    options={getOptions(masterData.types)}
                                    value={filters.productType}
                                    placeholder="Select Product Type"
                                    onChange={v => {

                                        setCurrentPage(1);

                                        // reset the type-specific filters whenever Product Type changes
                                        setFilters({
                                            ...filters,
                                            productType: v,
                                            cableType: null,
                                            category: null,
                                            referenceOfStandard: null,
                                            construction: null,
                                            cores: null,
                                            crossSection: null,
                                            voltage: null,
                                            color: '',
                                            subCategory: null,
                                            qualityCategory: null,
                                            code: '',
                                            assetCode: '',
                                            description: ''
                                        });

                                    }}
                                    isClearable
                                />
                            </div>

                            {activeFilterCount > 0 && (
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    style={{ fontSize: 12, height: 38, whiteSpace: "nowrap" }}
                                    onClick={clearAll}
                                >
                                    &times; Clear All ({activeFilterCount})
                                </button>
                            )}
                        </div>

                        {/* TYPE-SPECIFIC FILTERS + PRODUCT CODE / DESCRIPTION - all on one row */}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 15, marginTop: 15 }}>

                                <div style={fieldBox} title={filters.category?.label || ''}>
                                        <label style={styles.compactLabel}>Asset Category</label>
                                        <Select
                                            styles={customSelectStyles}
                                            options={toStrOptions(filterOptions.category)}
                                            value={filters.category}
                                            placeholder="Category"
                                            onChange={v => updateFilter({
                                                category: v,
                                                cableType: null,
                                                code: '',
                                                color: '',
                                                cores: null,
                                                crossSection: null,
                                                referenceOfStandard: null,
                                                voltage: null,
                                                construction: null,
                                                subCategory: null,
                                                qualityCategory: null
                                            })}
                                            isClearable
                                        />
                                    </div>

                                <div style={{ minWidth: 220 }}>
                                    <label style={styles.compactLabel}>Asset Code</label>
                                    <Select
                                        styles={customSelectStyles}
                                        options={codeDescList.map(item => ({
                                            value: item.assetCode,
                                            label: item.assetCode
                                        }))}
                                        value={filters.assetCode ? { label: filters.assetCode, value: filters.assetCode } : null}
                                        placeholder="Asset Code..."
                                        onChange={v => {
                                            const match = codeDescList.find(item => item.assetCode === (v ? v.value : ''));
                                            updateFilter({
                                                assetCode: v ? v.value : '',
                                                description: match ? (match.description || '') : ''
                                            });
                                        }}
                                        isClearable
                                    />
                                </div>

                                <div style={{ flex: 1, minWidth: 220 }}>
                                    <label style={styles.compactLabel}>Asset Description</label>
                                    <Select
                                        styles={customSelectStyles}
                                        options={codeDescList
                                            .filter(item => item.description)
                                            .map(item => ({
                                                value: item.description,
                                                label: item.description
                                            }))}
                                        value={filters.description ? { label: filters.description, value: filters.description } : null}
                                        placeholder="Asset Description..."
                                        onChange={v => {
                                            const match = codeDescList.find(item => item.description === (v ? v.value : ''));
                                            updateFilter({
                                                description: v ? v.value : '',
                                                assetCode: match ? (match.assetCode || '') : ''
                                            });
                                        }}
                                        isClearable
                                    />
                                </div>
                            </div>

                        <div style={{ marginTop: 8, fontSize: 13, color: "#16a34a", fontWeight: 600 }}>
                            {totalProducts} products match
                        </div>

                    </div>
                );
            })()}

            <div style={styles.tableContainer}>

                <table className="table" style={styles.erpTable}>

                    {(() => {

                        // Asset Master: one fixed column set for every row (no cable-type branching).
                        const columns = ["Asset Code", "Description", "Asset Category", "UOM", "Currency", "Price", "Cost", "Action"];

                        return (
                            <>
                                <thead>
                                    <tr>
                                        {columns.map(col => (
                                            <th key={col} style={styles.erpTh}>{col}</th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>

                                    {products.length > 0 ? (

                                        products.map((p, i) => (

                                            <tr key={i}>

                                                <td style={styles.erpTd}>{p.assetCode || "-"}</td>

                                                <td style={styles.erpTd}>{p.assetDescription || "-"}</td>

                                                <td style={styles.erpTd}>{p.assetCategory || "-"}</td>

                                                <td style={styles.erpTd}>{p.uom || "-"}</td>

                                                <td style={styles.erpTd}>{p.currency || "-"}</td>

                                                <td style={styles.erpTd}>{p.pricePerKm || "-"}</td>

                                                <td style={styles.erpTd}>{p.productCost || "-"}</td>

                                                <td style={styles.erpTd}>
                                                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                                        <button
                                                            className="btn btn-outline-dark btn-sm"
                                                            style={{
                                                                fontSize: "11px",
                                                                padding: "2px 8px"
                                                            }}
                                                            onClick={() =>
                                                                openViewModal(p.assetCode)
                                                            }
                                                        >
                                                            View
                                                        </button>
                                                        <button
                                                            title="Delete"
                                                            style={{
                                                                background: "#fff",
                                                                border: "1px solid #f5c2c7",
                                                                borderRadius: "4px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                padding: "4px 8px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() =>
                                                                handleDeleteProduct(p.assetCode)
                                                            }
                                                        >
                                                            <svg width="14" height="14" viewBox="0 0 16 16" fill="#dc3545" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3V2h11v1h-11Z"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </td>

                                            </tr>

                                        ))

                                    ) : (

                                        <tr>
                                            <td
                                                colSpan={columns.length}
                                                className="text-center text-muted p-3"
                                            >
                                                No assets found
                                            </td>
                                        </tr>

                                    )}

                                </tbody>
                            </>
                        );
                    })()}

                </table>

            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "15px",
                    width: "100%"
                }}
            >
                <button
                    className="btn btn-light"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {"<"}
                </button>

                <span>
                    Page {currentPage} of {totalPages}
                </span>

                <button
                    className="btn btn-light"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {">"}
                </button>
            </div>

            {/* ===================== MAIN FORM MODAL ===================== */}
            {isModalOpen && (
                <div style={styles.modalBackdrop}>
                    <div style={{ ...styles.modal, width: "95%" }}>

                        <div style={styles.modalHeader}>
                            <h3 style={{ margin: 0, color: '#1e293b', fontSize: '18px', fontWeight: 600 }}>
                                {isDraftView ? `Draft Asset Preview (${formData.assetCode})` : modalMode === 'edit' ? 'Edit Asset' : modalMode === 'view' ? 'View Asset' : 'Create Asset'}
                            </h3>
                            <button onClick={closeModal} style={styles.iconBtn}>✖</button>
                        </div>

                        <div style={styles.modalBody}>
                            <div className="card p-3 mb-3 bg-light border-0">

                                {/* ROW 1: Product Type is locked to "Asset" for this module; once picked, the Asset Category field appears */}
                                <div className="row g-3 mb-2">
                                    {renderSelect("Product Type", "productType", masterData.types, "col-md-3")}
                                </div>

                                {(() => {
                                    const selectedFormType = (formData.productType || "").trim().toLowerCase();

                                    if (!selectedFormType) return null;

                                    return (
                                        <div className="row g-3 mb-2">
                                            {renderCascadeSelect(
                                                "Asset Category", "assetCategory", namesOf(masterData.assetCategories), "col-md-3"
                                            )}
                                        </div>
                                    );
                                })()}

                            </div>


                            <div className="row g-3 mb-3 align-items-end">
                                <div className="col-md-4">
                                    <label style={styles.compactLabel}>Asset Code</label>
                                    <input type="text" className="form-control" style={styles.compactInput}
                                        value={formData.assetCode} onChange={e => setFormData({ ...formData, assetCode: e.target.value })}
                                        disabled={modalMode === 'view'} placeholder="Unique Code" />
                                </div>
                                {renderInput("Description", "description", "text", "col-md-4")}
                                {modalMode === "create" && (
                                    <div className="col-md-4">
                                        <label style={styles.compactLabel}>
                                            Reference Code
                                        </label>

                                        <Select
                                            styles={customSelectStyles}
                                            options={getOptions(masterData.assetCodes)}
                                            placeholder="Select to copy..."
                                            onChange={async (opt) => {

                                                if (!opt) return;

                                                try {

                                                    const res = await axios.get(
                                                        `${PURCHASE_API}/asset-master/assetDetailsByCode?assetCode=${opt.value}`
                                                    );

                                                    if (res.data.length > 0) {

                                                        const ref = res.data[0];

                                                        const parseLt = (str) => {

                                                            if (!str)
                                                                return {
                                                                    value: '',
                                                                    unit: ''
                                                                };

                                                            const parts = String(str).split(' ');

                                                            return {
                                                                value: parts[0] || '',
                                                                unit: parts.slice(1).join(' ') || ''
                                                            };
                                                        };
                                                        setFormData(prev => ({
                                                            ...initialFormState,
                                                            ...ref,

                                                            assetCode: prev.assetCode,
                                                            referenceAssetCode: opt.value,

                                                            procurementLeadTime: parseLt(ref.procurementLeadTime),
                                                            productionLeadTime: parseLt(ref.productionLeadTime)
                                                        }));

                                                        toast.info("Data copied!");
                                                    }

                                                } catch (e) {

                                                    toast.error("Ref Product not found");
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            <div style={styles.tabs}>
                                {(() => {

                                    // Asset Master: same tab set for every asset, MRP tab removed entirely.
                                    let tabs = [
                                        "basic",
                                        "sales",
                                        "purchase",
                                        "quality",
                                        "logistics",
                                        "accounting"
                                    ];

                                    // CHANGE LOG FOR ALL
                                    if (modalMode !== "create") {
                                        tabs.push("Change Log");
                                    }

                                    return tabs.map(t => (

                                        <button
                                            key={t}
                                            className={`btn btn-sm ${activeTab === t
                                                ? "btn-dark"
                                                : "btn-light"
                                                }`}
                                            style={{
                                                fontSize: '13px',
                                                padding: '5px 12px',
                                                border: '1px solid #eee'
                                            }}
                                            onClick={() => setActiveTab(t)}
                                        >
                                            {t.charAt(0).toUpperCase() + t.slice(1)}
                                        </button>

                                    ));

                                })()}

                            </div>

                            <div className="border rounded p-3">
                                {activeTab === 'basic' && (
                                    <div className="row g-3">
                                        <div className="col-md-6">
  <label style={styles.compactLabel}>Base Unit</label>
  <input
    type="number"
    className="form-control"
    style={styles.compactInput}
    value={formData.baseUnit || ""}
    onChange={(e) => {
      const baseUnit = Number(e.target.value || 0);
      const pricePerKm = Number(formData.pricePerKm || 0);

      setFormData(prev => ({
        ...prev,
        baseUnit: e.target.value,
        unitPrice:
          baseUnit > 0
            ? (pricePerKm / baseUnit).toFixed(2)
            : ""
      }));
    }}
    disabled={modalMode === "view"}
  />
</div>
                                        {renderSelect("UOM", "uom", masterData.uoms, "col-md-6")}






                                        {renderInput("Net Weight", "weight", "number", "col-md-6")}
                                        {renderSelect("UOM", "weightUom", masterData.uoms, "col-md-6")}


                                        <div className="col-md-6">
                                            {renderSelect(
                                                "HSN Code",
                                                "hsnCode",
                                                masterData.hsnCodes,
                                                "col-md-12"
                                            )}
                                        </div>

                                        <div className="col-md-5">
                                            {renderSelect(
                                                "Product Class",
                                                "productClass",
                                                filteredProductClasses,
                                                "col-md-12"
                                            )}
                                        </div>


                                        <div className="col-md-1 d-flex align-items-end">
                                            <button
                                                type="button"
                                                className="btn btn-sm"
                                                style={{
                                                    height: "32px",
                                                    width: "70px",
                                                    fontSize: "13px",
                                                    padding: "4px 10px",
                                                    background: "#021843",
                                                    color: "#fff",
                                                    border: "1px solid #021843"
                                                }}
                                                onClick={() => {

                                                    if (!formData.productClass) {
                                                        return toast.warning("Select Product Class");
                                                    }

                                                    let returnTo;

                                                    // if (modalMode === 'view') {
                                                    //     returnTo = encodeURIComponent(
                                                    //         `/cable/product/product-code?view=${formData.assetCode}`
                                                    //     );
                                                    if (modalMode === "view") {

                                                        sessionStorage.setItem(
                                                            "productViewResumeState",
                                                            JSON.stringify({
                                                                formData,
                                                                productLogs,
                                                                modalMode,
                                                                activeTab,
                                                                pgCount,
                                                                cccCount
                                                            })
                                                        );

                                                        returnTo = encodeURIComponent(
                                                            `/cable/product/product-code?resumeView=1`
                                                        );
                                                    } else {
                                                        // Create/Edit mode: the product isn't saved yet, so it
                                                        // can't be re-fetched by code. Stash the in-progress
                                                        // form so we can restore the same modal on return.
                                                        sessionStorage.setItem(
                                                            "productModalResumeState",
                                                            JSON.stringify({
                                                                modalMode,
                                                                formData,
                                                                activeTab,
                                                                pgCount,
                                                                cccCount
                                                            })
                                                        );

                                                        returnTo = encodeURIComponent(
                                                            `/cable/product/product-code?resume=1`
                                                        );
                                                    }

                                                    navigate(
                                                        `/cable/product/product-configuration/${formData.productClass}?returnTo=${returnTo}`
                                                    );
                                                }}
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                )}


                                {activeTab === 'sales' && (
                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <label style={styles.compactLabel}>Item Category</label>

                                            <select
                                                className="form-select"
                                                style={styles.compactInput}
                                                value={formData.itemCategory || ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        itemCategory: e.target.value
                                                    })
                                                }
                                                disabled={modalMode === 'view'}
                                            >
                                                <option value="">Select</option>
                                                <option value="MTS">MTS</option>
                                                <option value="MTO">MTO</option>
                                            </select>
                                        </div>

                                        {renderSelect(
                                            "Product Status(sales)",
                                            "sales_status",
                                            masterData.statuses,
                                            "col-md-6",
                                            false
                                        )}
                                        {renderSelect(
                                            "Sales Organization",
                                            "salesOrganization",
                                            masterData.salesOrganizations,
                                            "col-md-6"
                                        )}



                                        {renderSelect(
                                            "Shipping From",
                                            "shippingFrom",
                                            masterData.shippingFroms,
                                            "col-md-6"
                                        )}

                                        {renderSelect(
                                            "Distribution Channel",
                                            "distributionChannel",
                                            masterData.distributionChannels,
                                            "col-md-6"
                                        )}



                                    </div>
                                )}

                                {activeTab === 'purchase' && (
                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <label style={styles.compactLabel}>Procurement Type</label>

                                            <select
                                                className="form-select"
                                                style={styles.compactInput}
                                                value={formData.procurementType || ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        procurementType: e.target.value
                                                    })
                                                }
                                                disabled={modalMode === 'view'}
                                            >
                                                <option value="">Select</option>
                                                <option value="Manufactured">Manufactured</option>
                                                <option value="Outsourced">Outsourced</option>
                                                <option value="Both">Both</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label style={styles.compactLabel}>Procurement Lead Time</label>
                                            <div className="d-flex gap-2">
                                                <input type="number" className="form-control" style={styles.compactInput}
                                                    value={formData.procurementLeadTime.value}
                                                    onChange={e => setFormData({ ...formData, procurementLeadTime: { ...formData.procurementLeadTime, value: e.target.value } })}
                                                    disabled={modalMode === 'view'} placeholder="Val" />
                                                <select className="form-select" style={styles.compactInput}
                                                    value={formData.procurementLeadTime?.unit || ""}
                                                    onChange={e => setFormData({ ...formData, procurementLeadTime: { value: formData.procurementLeadTime?.value || "", unit: e.target.value } })}
                                                    disabled={modalMode === 'view'}>
                                                    <option value="">Unit</option>
                                                    {getOptions(masterData.uoms).map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                      <div className="col-md-6">
    <label style={styles.compactLabel}>MOQ</label>

    <div style={{ display: "flex", gap: "8px" }}>
        <input
            type="number"
            className="form-control"
            style={{ ...styles.compactInput, flex: 1 }}
            value={formData.moq || ""}
            onChange={(e) =>
                setFormData({
                    ...formData,
                    moq: e.target.value
                })
            }
            disabled={modalMode === "view"}
            placeholder="Enter MOQ"
        />

        <Select
            styles={customSelectStyles}
            options={getOptions(masterData.uoms)}
            value={
                getOptions(masterData.uoms).find(
                    o => o.value === formData.moq_uom
                ) || null
            }
            onChange={(v) =>
                setFormData({
                    ...formData,
                    moq_uom: v ? v.value : ""
                })
            }
            isDisabled={modalMode === "view"}
            placeholder="UOM"
            isClearable
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
            className="uom-select"
        />
    </div>
</div>
                                        {renderSelect("Country of Origin", "countryOfOrigin", masterData.countries, "col-md-6")}
                                        {renderSelect("Product Status(purchase)", "purchase_status", masterData.statuses, "col-md-6", false)}

                                        <div className="col-md-5">
                                            {renderSelect(
                                                "Purchase Class",
                                                "purchaseClass",
                                                allProductClasses,
                                                "col-md-12"
                                            )}
                                        </div>

                                        <div className="col-md-1 d-flex align-items-end">
                                            <button
                                                type="button"
                                                className="btn btn-sm"
                                                style={{
                                                    height: "32px",
                                                    width: "70px",
                                                    fontSize: "13px",
                                                    padding: "4px 10px",
                                                    background: "#021843",
                                                    color: "#fff",
                                                    border: "1px solid #021843"
                                                }}
                                                onClick={() => {

                                                    if (!formData.purchaseClass) {
                                                        return toast.warning("Select Purchase Class");
                                                    }

                                                    let returnTo;

                                                    if (modalMode === "view") {

                                                        sessionStorage.setItem(
                                                            "productViewResumeState",
                                                            JSON.stringify({
                                                                formData,
                                                                productLogs,
                                                                modalMode,
                                                                activeTab,
                                                                pgCount,
                                                                cccCount
                                                            })
                                                        );

                                                        returnTo = encodeURIComponent(
                                                            `/cable/product/product-code?resumeView=1`
                                                        );
                                                    } else {
                                                        sessionStorage.setItem(
                                                            "productModalResumeState",
                                                            JSON.stringify({
                                                                modalMode,
                                                                formData,
                                                                activeTab,
                                                                pgCount,
                                                                cccCount
                                                            })
                                                        );

                                                        returnTo = encodeURIComponent(
                                                            `/cable/product/product-code?resume=1`
                                                        );
                                                    }

                                                    navigate(
                                                        `/cable/product/product-configuration/${formData.purchaseClass}?returnTo=${returnTo}`
                                                    );
                                                }}
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'quality' && (
                                    <div className="row g-3">
                                        {renderSelect("Relevant for Quality", "relevantForQuality", ["Yes", "No"], "col-md-6", false)}
                                        {renderSelect("Product Status(Quality)", "quality_status", masterData.statuses, "col-md-6", false)}
                                    </div>
                                )}

                                {activeTab === 'logistics' && (
                                    <div className="row g-3">
                                        {renderInput("Storage Type", "storageType")}
                                        {renderSelect("Product Status(Logistics)", "logistics_status", masterData.statuses, "col-md-6", false)}
                                    </div>
                                )}


                              {activeTab === 'accounting' && (
  <div className="row g-3">

    {renderInput(
      "Product Cost",
      "productCost",
      "number",
      "col-md-6",
      (formData.productType || '').toLowerCase() !== 'raw material'
    )}

    {renderSelect(
      "Currency",
      "currency",
      masterData.currencies,
      "col-md-6"
    )}

    {/* Price Per KM */}
    <div className="col-md-6">
      <label style={styles.compactLabel}>
        Price Per KM
      </label>

      <input
        type="number"
        className="form-control"
        style={styles.compactInput}
        value={formData.pricePerKm || ""}
        onChange={(e) => {
          const pricePerKm = Number(e.target.value || 0);
          const baseUnit = Number(formData.baseUnit || 0);

          setFormData(prev => ({
            ...prev,
            pricePerKm: e.target.value,
            unitPrice:
              baseUnit > 0
                ? (pricePerKm / baseUnit).toFixed(2)
                : ""
          }));
        }}
        disabled={modalMode === "view"}
      />
    </div>

    {/* Unit Price */}
    <div className="col-md-6">
      <label style={styles.compactLabel}>
        Unit Price
      </label>

      <input
  type="number"
  className="form-control"
  style={styles.compactInput}
  value={formData.unitPrice || ""}
  onChange={(e) =>
    setFormData(prev => ({
      ...prev,
      unitPrice: e.target.value
    }))
  }
  disabled={modalMode === "view"}
/>
    </div>

    {renderInput(
      "Moving Avg Price",
      "movingAveragePrice",
      "number"
    )}

    {renderSelect(
      "ProductStatus(Accounting)",
      "accounting_status",
      masterData.statuses,
      "col-md-6",
      false
    )}

  </div>
)}
                                {activeTab === "Change Log" && (
                                    <div style={styles.tableContainer}>
                                        <table className="table" style={styles.erpTable}>
                                            <thead>
                                                <tr>
                                                    <th style={styles.erpTh}>Date & Time</th>
                                                    <th style={styles.erpTh}>User</th>
                                                    <th style={styles.erpTh}>Action</th>
                                                    <th style={styles.erpTh}>Status</th>
                                                    <th style={styles.erpTh}>Field</th>
                                                    <th style={styles.erpTh}>Old Value</th>
                                                    <th style={styles.erpTh}>New Value</th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {productLogs.length > 0 ? productLogs.map((log) => {

                                                    const dateVal = log.updated_at || log.created_at;
                                                    const userVal = log.updated_by || log.created_by;

                                                    return (
                                                        <tr key={log.id}>

                                                            <td style={styles.erpTd}>
                                                                {dateVal
                                                                    ? new Date(dateVal).toLocaleString('en-IN', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric',
                                                                        hour: '2-digit',
                                                                        minute: '2-digit'
                                                                    })
                                                                    : '-'}
                                                            </td>

                                                            <td style={styles.erpTd}>
                                                                {userVal || "-"}
                                                            </td>

                                                            <td style={styles.erpTd}>
                                                                {log.action_type || "-"}
                                                            </td>

                                                            <td style={styles.erpTd}>
                                                                {log.doc_status || "-"}
                                                            </td>

                                                            <td style={styles.erpTd}>
                                                                {log.field_name
                                                                    ? log.field_name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                                                                    : '-'}
                                                            </td>

                                                            <td style={{ ...styles.erpTd }}>
                                                                {log.old_value || '-'}
                                                            </td>

                                                            <td style={{ ...styles.erpTd, fontWeight: 600 }}>
                                                                {log.new_value || '-'}
                                                            </td>

                                                            <td style={styles.erpTd}>
                                                                {log.comment || '-'}
                                                            </td>

                                                        </tr>
                                                    );
                                                }) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center text-muted p-3">
                                                            No change logs available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={styles.modalFooter}>
                            <button className="btn btn-outline-secondary" onClick={closeModal}>
                                {isDraftView ? 'Close Preview' : 'Cancel'}
                            </button>

                            {/* Save button for Creating new, Editing main, or Editing Draft */}
                            {(modalMode === 'create' || modalMode === 'edit' || modalMode === 'edit_draft') && (
                                <button
                                    className="btn btn-dark"
                                    onClick={() => {
                                        if (modalMode === "create" && !canCreate) {
                                            toast.error("You don't have Create access. Please contact admin.");
                                            return;
                                        }

                                        if (modalMode !== "create" && !canEdit) {
                                            toast.error("You don't have Edit access. Please contact admin.");
                                            return;
                                        }

                                        handleSave();

                                    }}

                                >
                                    Save
                                </button>
                            )}

                            {/* Edit button for Main Product */}
                            {modalMode === 'view' && !isDraftView && (
                                <button
                                    className="btn btn-dark"
                                    onClick={() => {
                                        if (!canEdit) {
                                            toast.error("You don't have Edit access. Please contact admin.");
                                            return;
                                        }

                                        setModalMode("edit");
                                    }}
                                >
                                    Edit
                                </button>
                            )}

                            {/* Edit button for Draft Product */}
                            {modalMode === 'view_draft' && isDraftView && (
                                <button
                                    className="btn btn-dark"
                                    onClick={() => {
                                        if (!canEdit) {
                                            toast.error("You don't have Edit access. Please contact admin.");
                                            return;
                                        }
                                        setModalMode("edit_draft");
                                    }}
                                >
                                    Edit Draft
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <CharacteristicsModal
                modalVisible={showMrpCharModal}
                selectedCharacteristics={mrpCharacteristics}
                isEditing={modalMode !== 'view'}
                handleChange={(idx, val) => {
                    if (modalMode === 'view') return;
                    const updated = [...mrpCharacteristics];
                    updated[idx] = { ...updated[idx], value: val };
                    setMrpCharacteristics(updated);
                }}
                handleClose={() => {
                    // On close: if edit/create mode, save; if view, just close
                    if (modalMode !== 'view') {
                        handleSaveMrpCharModal(mrpCharacteristics);
                    } else {
                        setShowMrpCharModal(false);
                    }
                }}
            />



            {/* ===================== FLOATING DRAFTS BADGE ===================== */}
            <div style={{ position: 'fixed', bottom: 30, right: 30, display: 'flex', flexDirection: 'column', gap: 15, zIndex: 9999 }}>
                {draftsList.length > 0 && (
                    <div onClick={() => setShowDraftModal(true)} style={{ background: '#1e293b', color: '#fff', padding: '12px 20px', borderRadius: 50, cursor: 'pointer', boxShadow: '0 8px 20px rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontWeight: 'bold', fontSize: 15 }}>📂 Pending Drafts</span>
                        <span style={{ background: '#ef4444', color: 'white', padding: '2px 8px', borderRadius: 20, fontSize: 12, fontWeight: 'bold' }}>{draftsList.length}</span>
                    </div>
                )}
            </div>

            {/* ===================== DELETE CONFIRM MODAL ===================== */}
            {showDeleteConfirm && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    zIndex: 1070,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        background: "#fff",
                        width: "420px",
                        borderRadius: 14,
                        padding: "36px 32px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        textAlign: "center",
                        position: "relative"
                    }}>
                        {/* CLOSE */}
                        <button
                            onClick={() => {
                                setShowDeleteConfirm(false);
                                setProductToDelete(null);
                            }}
                            style={{
                                position: "absolute",
                                top: 16,
                                right: 18,
                                background: "transparent",
                                border: "none",
                                fontSize: 18,
                                cursor: "pointer",
                                color: "#94a3b8"
                            }}
                        >
                            ✖
                        </button>

                        {/* ICON BADGE */}
                        <div style={{
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            background: "#ef4444",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            fontSize: 28,
                            color: "#fff",
                            fontWeight: "bold"
                        }}>
                            🗑
                        </div>

                        {/* TITLE */}
                        <h4 style={{
                            margin: "0 0 12px",
                            fontSize: "19px",
                            fontWeight: 700,
                            color: "#1e293b"
                        }}>
                            Delete Product
                        </h4>

                        {/* MESSAGE */}
                        <p style={{
                            fontSize: 14,
                            color: "#64748b",
                            marginBottom: 28,
                            lineHeight: 1.5
                        }}>
                            Delete product "{productToDelete}"? This will hide it from the list.
                        </p>

                        {/* ACTIONS */}
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10
                        }}>
                            <button
                                onClick={confirmDeleteProduct}
                                style={{
                                    padding: "12px 16px",
                                    borderRadius: 10,
                                    border: "none",
                                    background: "#ef4444",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    width: "100%"
                                }}
                            >
                                Yes, Delete Product
                            </button>

                            <button
                                onClick={() => {
                                    setShowDeleteConfirm(false);
                                    setProductToDelete(null);
                                }}
                                style={{
                                    padding: "10px 16px",
                                    borderRadius: 10,
                                    border: "none",
                                    background: "transparent",
                                    color: "#334155",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    width: "100%"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ===================== DELETE DRAFT CONFIRM MODAL ===================== */}
            {showDeleteDraftConfirm && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    zIndex: 1080,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        background: "#fff",
                        width: "420px",
                        borderRadius: 14,
                        padding: "36px 32px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        textAlign: "center",
                        position: "relative"
                    }}>
                        <button
                            onClick={() => {
                                setShowDeleteDraftConfirm(false);
                                setDraftToDelete(null);
                            }}
                            style={{
                                position: "absolute",
                                top: 16,
                                right: 18,
                                background: "transparent",
                                border: "none",
                                fontSize: 18,
                                cursor: "pointer",
                                color: "#94a3b8"
                            }}
                        >
                            ✖
                        </button>

                        <div style={{
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            background: "#ef4444",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            fontSize: 28,
                            color: "#fff",
                            fontWeight: "bold"
                        }}>
                            🗑
                        </div>

                        <h4 style={{
                            margin: "0 0 12px",
                            fontSize: "19px",
                            fontWeight: 700,
                            color: "#1e293b"
                        }}>
                            Delete Draft
                        </h4>

                        <p style={{
                            fontSize: 14,
                            color: "#64748b",
                            marginBottom: 28,
                            lineHeight: 1.5
                        }}>
                            Delete draft product "{draftToDelete}"? This cannot be undone.
                        </p>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10
                        }}>
                            <button
                                onClick={confirmDeleteDraft}
                                style={{
                                    padding: "12px 16px",
                                    borderRadius: 10,
                                    border: "none",
                                    background: "#ef4444",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    width: "100%"
                                }}
                            >
                                Yes, Delete Draft
                            </button>

                            <button
                                onClick={() => {
                                    setShowDeleteDraftConfirm(false);
                                    setDraftToDelete(null);
                                }}
                                style={{
                                    padding: "10px 16px",
                                    borderRadius: 10,
                                    border: "none",
                                    background: "transparent",
                                    color: "#334155",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    width: "100%"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showReplaceConfirm && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    background: "rgba(0,0,0,0.5)", zIndex: 1070,
                    display: "flex", justifyContent: "center", alignItems: "center"
                }}>
                    <div style={{
                        background: "#fff", width: "420px", borderRadius: 14,
                        padding: "36px 32px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        textAlign: "center", position: "relative"
                    }}>
                        <button
                            onClick={() => setShowReplaceConfirm(false)}
                            style={{
                                position: "absolute", top: 16, right: 18,
                                background: "transparent", border: "none",
                                fontSize: 18, cursor: "pointer", color: "#94a3b8"
                            }}
                        >
                            ✖
                        </button>
                        <h4 style={{ margin: "0 0 12px", fontSize: "19px", fontWeight: 700, color: "#1e293b" }}>
                            Product Already Deleted
                        </h4>
                        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 28, lineHeight: 1.5 }}>
                            Product "{formData.assetCode}" already exists but is deleted.
                            Do you want to replace it with this new data?
                        </p>
                       <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <button
                                onClick={() => {
                                    setShowReplaceConfirm(false);
                                    handleSave(true); // YES -> replace the deleted row
                                }}
                                style={{
                                    padding: "12px 16px", borderRadius: 10, border: "none",
                                    background: "#16a34a", color: "#fff", cursor: "pointer",
                                    fontWeight: 600, fontSize: 14, width: "100%"
                                }}
                            >
                                Yes, Replace It
                            </button>
                            <button
                                onClick={() => {
                                    setShowReplaceConfirm(false);
                                }}
                                style={{
                                    padding: "10px 16px", borderRadius: 10, border: "none",
                                    background: "transparent", color: "#334155", cursor: "pointer",
                                    fontWeight: 500, fontSize: 14, width: "100%"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* PER-ROW DRAFT REPLACE CONFIRM */}
            {showDraftReplaceConfirm && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    background: "rgba(0,0,0,0.5)", zIndex: 1080,
                    display: "flex", justifyContent: "center", alignItems: "center"
                }}>
                    <div style={{
                        background: "#fff", width: "420px", borderRadius: 14,
                        padding: "36px 32px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        textAlign: "center", position: "relative"
                    }}>
                        <button
                            onClick={() => {
                                setShowDraftReplaceConfirm(false);
                                setDraftReplaceTarget(null);
                            }}
                            style={{
                                position: "absolute", top: 16, right: 18,
                                background: "transparent", border: "none",
                                fontSize: 18, cursor: "pointer", color: "#94a3b8"
                            }}
                        >
                            ✖
                        </button>
                        <h4 style={{ margin: "0 0 12px", fontSize: "19px", fontWeight: 700, color: "#1e293b" }}>
                            Product Already Deleted
                        </h4>
                        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 28, lineHeight: 1.5 }}>
                            Product "{draftReplaceTarget}" already exists but is deleted.
                            Do you want to replace it with this new data?
                        </p>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <button
                                onClick={() => {
                                    const code = draftReplaceTarget;
                                    setShowDraftReplaceConfirm(false);
                                    handlePublishDraft(code, true);
                                }}
                                style={{
                                    padding: "12px 16px", borderRadius: 10, border: "none",
                                    background: "#16a34a", color: "#fff", cursor: "pointer",
                                    fontWeight: 600, fontSize: 14, width: "100%"
                                }}
                            >
                                Yes, Replace It
                            </button>
                            <button
                                onClick={() => {
                                    setShowDraftReplaceConfirm(false);
                                    setDraftReplaceTarget(null);
                                }}
                                style={{
                                    padding: "10px 16px", borderRadius: 10, border: "none",
                                    background: "transparent", color: "#334155", cursor: "pointer",
                                    fontWeight: 500, fontSize: 14, width: "100%"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* SAVE-ALL BULK REPLACE CONFIRM */}
            {showBulkReplaceConfirm && (() => {

                const conflictsInList = draftsList
                    .map(d => d.assetCode)
                    .filter(code => deletedConflictCodes.includes(code));

                return (
                    <div style={{
                        position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                        background: "rgba(0,0,0,0.5)", zIndex: 1080,
                        display: "flex", justifyContent: "center", alignItems: "center"
                    }}>
                        <div style={{
                            background: "#fff", width: "460px", borderRadius: 14,
                            padding: "36px 32px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                            textAlign: "center", position: "relative"
                        }}>
                            <button
                                onClick={() => setShowBulkReplaceConfirm(false)}
                                style={{
                                    position: "absolute", top: 16, right: 18,
                                    background: "transparent", border: "none",
                                    fontSize: 18, cursor: "pointer", color: "#94a3b8"
                                }}
                            >
                                ✖
                            </button>
                            <h4 style={{ margin: "0 0 12px", fontSize: "19px", fontWeight: 700, color: "#1e293b" }}>
                                Some Products Are Already Deleted
                            </h4>
                            <p style={{ fontSize: 14, color: "#64748b", marginBottom: 28, lineHeight: 1.5 }}>
                                <strong>{conflictsInList.join(", ")}</strong>{" "}
                                {conflictsInList.length > 1 ? "already exist" : "already exists"} but{" "}
                                {conflictsInList.length > 1 ? "are" : "is"} deleted.
                                Do you want to replace {conflictsInList.length > 1 ? "them" : "it"} with the new data?
                            </p>
                            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                <button
                                    onClick={() => {
                                        setShowBulkReplaceConfirm(false);
                                        publishAllDraftsApi(true);
                                    }}
                                    style={{
                                        padding: "12px 16px", borderRadius: 10, border: "none",
                                        background: "#16a34a", color: "#fff", cursor: "pointer",
                                        fontWeight: 600, fontSize: 14, width: "100%"
                                    }}
                                >
                                    Yes, Replace All
                                </button>
                                <button
                                    onClick={() => {
                                        setShowBulkReplaceConfirm(false);
                                    }}
                                    style={{
                                        padding: "10px 16px", borderRadius: 10, border: "none",
                                        background: "transparent", color: "#334155", cursor: "pointer",
                                        fontWeight: 500, fontSize: 14, width: "100%"
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ===================== UPLOAD MODAL ===================== */}
            {showUploadModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    zIndex: 1060,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>

                    <div style={{
                        background: "#fff",
                        width: "450px",
                        borderRadius: 12,
                        padding: 25,
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
                    }}>

                        {/* HEADER */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 20
                        }}>
                            <h4 style={{
                                margin: 0,
                                fontSize: "18px",
                                color: "#1e293b"
                            }}>
                                Upload Products
                            </h4>

                            <button
                                onClick={() => setShowUploadModal(false)}
                                style={{
                                    background: "transparent",
                                    border: "none",
                                    fontSize: 18,
                                    cursor: "pointer",
                                    color: "#64748b"
                                }}
                            >
                                ✖
                            </button>
                        </div>

                        {/* CONTENT */}
                        <div style={{
                            background: "#f8fafc",
                            border: "2px dashed #cbd5e1",
                            borderRadius: 8,
                            padding: 20
                        }}>

                            {/* TEMPLATE ROWS */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 12
                            }}>
                                <span style={{ fontSize: 14, fontWeight: 500 }}>
                                    Finished Goods
                                </span>

                                <a
                                    href="/assets/files/PM Finished goods.xlsx"
                                    download
                                    style={styles.downloadBtn}
                                >
                                    Download Template
                                </a>
                            </div>

                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 12
                            }}>
                                <span style={{ fontSize: 14, fontWeight: 500 }}>
                                    Semi Finished Goods
                                </span>

                                <a
                                    href="/assets/files/PM Finished goods.xlsx"
                                    download
                                    style={styles.downloadBtn}
                                >
                                    Download Template
                                </a>
                            </div>

                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 20
                            }}>
                                <span style={{ fontSize: 14, fontWeight: 500 }}>
                                    Raw Materials
                                </span>

                                <a
                                    href="/assets/files/PM raw materials.xlsx"
                                    download
                                    style={styles.downloadBtn}
                                >
                                    Download Template
                                </a>
                            </div>

                            {/* BROWSE FILE */}
                            <div style={{ textAlign: "center" }}>

                                <input
                                    type="file"
                                    id="productExcelUpload"
                                    accept=".xlsx,.xls,.csv"
                                    style={{ display: "none" }}
                                    onChange={handleBulkExcelUpload}
                                />

                                <label
                                    htmlFor="productExcelUpload"
                                    style={styles.browseBtn}
                                >
                                    Browse File
                                </label>

                            </div>

                        </div>

                    </div>

                </div>
            )}
            {showUpdateModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.5)",
                    zIndex: 1060,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        borderRadius: 12,
                        padding: 25,
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
                    }}>

                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 20
                        }}>
                            <h4 style={{ margin: 0, fontSize: "18px" }}>Update Products</h4>
                            <button
                                onClick={() => setShowUpdateModal(false)}
                                style={{ background: "transparent", border: "none", fontSize: 18, cursor: "pointer" }}
                            >
                                ✖
                            </button>
                        </div>

                        <div style={{
                            border: "2px dashed #cbd5e1",
                            borderRadius: 8,
                            padding: 30,
                            textAlign: "center",
                            background: "#f8fafc"
                        }}>
                            <p style={{ marginBottom: 15 }}>Upload your Price Per KM Updated File</p>

                            <input
                                type="file"
                                id="updateExcelUpload"
                                accept=".xlsx, .xls, .csv"
                                style={{ display: "none" }}
                                onChange={handleUpdateExcel}
                            />

                            <label
                                htmlFor="updateExcelUpload"
                                style={{
                                    background: "#021843",
                                    color: "white",
                                    padding: "8px 20px",
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    display: "inline-block",
                                    marginBottom: 15
                                }}
                            >
                                Browse File
                            </label>

                            <div>
                                <a
                                    href="/assets/files/product std_price.xlsx"
                                    download
                                    style={{
                                        fontSize: 13,
                                        color: "#021843",
                                        textDecoration: "none",
                                        fontWeight: 500
                                    }}
                                >
                                    ⬇ Download Template
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            {/* ===================== MASTER PREVIEW DRAFT MODAL ===================== */}
            {/* ===================== MASTER PREVIEW DRAFT MODAL ===================== */}
            {showDraftModal && (
                <div style={styles.modalBackdrop}>

                    <div
                        style={{
                            ...styles.modal,
                            width: "80%",
                            maxWidth: "950px",
                            maxHeight: "85vh"
                        }}
                    >

                        {/* HEADER */}
                        <div style={styles.modalHeader}>

                            <div
                                style={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    color: "#1e293b"
                                }}
                            >
                                👀 Preview Uploaded Products
                            </div>

                            <button
                                onClick={() => setShowDraftModal(false)}
                                style={styles.iconBtn}
                            >
                                ✖
                            </button>

                        </div>

                        {/* BODY */}
                        <div style={styles.modalBody}>

                            {draftsList.length === 0 ? (

                                <p
                                    style={{
                                        textAlign: "center",
                                        marginTop: 40,
                                        color: "#64748b"
                                    }}
                                >
                                    No Pending Products found.
                                </p>

                            ) : (

                                <table className="table table-hover align-middle">

                                    <thead className="table-light">

                                        <tr>

                                            <th>Asset Code</th>

                                            <th>Description</th>

                                            <th>Group</th>

                                            <th>Type</th>

                                            <th>Actions</th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {draftsList.map((draft) => (

                                            <tr key={draft.assetCode}>

                                                <td>
                                                    <strong>
                                                        {draft.assetCode}
                                                    </strong>
                                                </td>
                                                <td>
                                                    {draft.assetDescription || "-"}
                                                </td>

                                                <td>
                                                    {draft.assetCategory || "-"}
                                                </td>

                                                <td>
                                                    {draft.productType || "-"}
                                                </td>

                                                <td>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px"
                                                        }}
                                                    >

                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            style={{
                                                                minWidth: "70px",
                                                                height: "32px",
                                                                fontSize: "13px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                            onClick={() => openDraftView(draft)}
                                                        >
                                                            View
                                                        </button>

                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            style={{
                                                                minWidth: "70px",
                                                                height: "32px",
                                                                fontSize: "13px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                            onClick={() => {

                                                                if (!canCreate) {
                                                                    toast.error("You don't have Create access. Please contact admin.");
                                                                    return;
                                                                }

                                                                onClickPublishDraft(
                                                                    draft.assetCode
                                                                );
                                                            }}
                                                            disabled={
                                                                publishingId === draft.assetCode ||
                                                                isPublishingAll
                                                            }
                                                        >
                                                            {publishingId === draft.assetCode
                                                                ? "Saving..."
                                                                : "Save"}
                                                        </button>

                                                        <button
                                                            title="Delete Draft"
                                                            style={{
                                                                background: "#fff",
                                                                border: "1px solid #f5c2c7",
                                                                borderRadius: "4px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                padding: "4px 8px",
                                                                height: "32px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() =>
                                                                handleDeleteDraft(draft.assetCode)
                                                            }
                                                        >
                                                            <svg width="14" height="14" viewBox="0 0 16 16" fill="#dc3545" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3V2h11v1h-11Z"/>
                                                            </svg>
                                                        </button>

                                                    </div>
                                                </td>

                                            </tr>

                                        ))}

                                    </tbody>

                                </table>

                            )}

                        </div>

                        {/* FOOTER */}
                        {draftsList.length > 0 && (

                            <div style={styles.modalFooter}>

                                <button
                                    className="btn btn-light"
                                    onClick={() => setShowDraftModal(false)}
                                >
                                    Close
                                </button>

                                <button
                                    className="btn btn-success"
                                    onClick={() => {

                                        if (!canCreate) {
                                            toast.error("You don't have Create access. Please contact admin.");
                                            return;
                                        }

                                        handlePublishAllDrafts();
                                    }}
                                    disabled={isPublishingAll}
                                >
                                    {isPublishingAll
                                        ? "Saving All..."
                                        : "Save All"}
                                </button>

                            </div>

                        )}

                    </div>

                </div>
            )}


            {showConfigViewModal && (
                <div style={styles.modalBackdropHigher}>

                    <div
                        style={{
                            ...styles.modal,
                            width: "85%",
                            maxWidth: "1250px"
                        }}
                    >

                        {/* HEADER */}
                        <div style={styles.modalHeader}>

                            <h3
                                style={{
                                    margin: 0,
                                    color: '#1e293b',
                                    fontSize: '18px',
                                    fontWeight: 600
                                }}
                            >
                                {selectedConfig?.class_code || "Product Configuration"}
                            </h3>

                            <button
                                onClick={() => setShowConfigViewModal(false)}
                                style={styles.iconBtn}
                            >
                                ✖
                            </button>

                        </div>

                        <div style={styles.modalBody}>

                            {/* TOP DETAILS */}

                            <div className="card p-3 mb-4 bg-light border-0">

                                <div className="row g-3 mb-3">

                                    <div className="col-md-3">
                                        <label style={styles.compactLabel}>
                                            Organization
                                        </label>

                                        <input
                                            className="form-control"
                                            style={styles.compactInput}
                                            value={selectedConfig?.organization || ""}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label style={styles.compactLabel}>
                                            Sales Organization
                                        </label>

                                        <input
                                            className="form-control"
                                            style={styles.compactInput}
                                            value={selectedConfig?.sales_organization || ""}
                                            disabled
                                        />
                                    </div>



                                    <div className="col-md-3">
                                        <label style={styles.compactLabel}>
                                            Product Type
                                        </label>

                                        <input
                                            className="form-control"
                                            style={styles.compactInput}
                                            value={selectedConfig?.product_type || ""}
                                            disabled
                                        />
                                    </div>

                                </div>

                                <div className="row g-3">

                                    <div className="col-md-6">
                                        <label style={styles.compactLabel}>
                                            Class Code
                                        </label>

                                        <input
                                            className="form-control"
                                            style={styles.compactInput}
                                            value={selectedConfig?.class_code || ""}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label style={styles.compactLabel}>
                                            Description
                                        </label>

                                        <input
                                            className="form-control"
                                            style={styles.compactInput}
                                            value={selectedConfig?.description || ""}
                                            disabled
                                        />
                                    </div>

                                </div>

                            </div>

                            {/* CHARACTERISTICS */}

                            <div style={styles.tableContainer}>

                                <table
                                    className="table"
                                    style={styles.erpTable}
                                >

                                    <thead>

                                        <tr>

                                            <th style={styles.erpTh}>
                                                Characteristic
                                            </th>

                                            <th style={styles.erpTh}>
                                                Calculation Type
                                            </th>

                                            <th style={styles.erpTh}>
                                                Operation
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {selectedConfig?.characteristics?.length > 0 ? (

                                            selectedConfig.characteristics.map(
                                                (char, index) => (

                                                    <tr key={index}>

                                                        <td style={styles.erpTd}>
                                                            {char.characteristic || "-"}
                                                        </td>

                                                        <td style={styles.erpTd}>

                                                            <Select
                                                                styles={customSelectStyles}
                                                                value={
                                                                    (char.calculationType || []).map(
                                                                        item => ({
                                                                            value: item,
                                                                            label: item
                                                                        })
                                                                    )
                                                                }
                                                                isMulti
                                                                isDisabled
                                                            />

                                                        </td>

                                                        <td style={styles.erpTd}>

                                                            <Select
                                                                styles={customSelectStyles}
                                                                value={
                                                                    (char.selectedOperations || []).map(
                                                                        item => ({
                                                                            value: item,
                                                                            label: item
                                                                        })
                                                                    )
                                                                }
                                                                isMulti
                                                                isDisabled
                                                            />

                                                        </td>

                                                    </tr>
                                                )
                                            )

                                        ) : (

                                            <tr>

                                                <td
                                                    colSpan="3"
                                                    className="text-center"
                                                    style={styles.erpTd}
                                                >
                                                    No characteristics found
                                                </td>

                                            </tr>

                                        )}

                                    </tbody>

                                </table>

                            </div>

                        </div>

                        <div style={styles.modalFooter}>

                            <button
                                className="btn btn-outline-secondary"
                                onClick={() =>
                                    setShowConfigViewModal(false)
                                }
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>
            )}

            <ToastContainer position="top-right" autoClose={3000} />



        </Layout>
    );
}

const styles = {

    downloadBtn: {
        background: "#021843",
        color: "#fff",
        padding: "6px 16px",
        borderRadius: 6,
        textDecoration: "none",
        fontSize: 13,
        fontWeight: 600
    },

    browseBtn: {
        background: "#021843",
        color: "#fff",
        padding: "10px 24px",
        borderRadius: 6,
        cursor: "pointer",
        fontWeight: 600,
        display: "inline-block"
    },
    compactLabel: { fontSize: "12px", fontWeight: 600, marginBottom: "2px", color: '#334155' },
    boldLabel: {
        fontSize: "12px",
        fontWeight: "bold",
        marginBottom: "2px",
        color: "#334155"
    },
    compactInput: { fontSize: "13px", height: "32px", padding: "4px 8px" },
    filterCard: { background: '#ffffff', borderRadius: 8, padding: 15, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 15 },
    tableContainer: { background: "#ffffff", borderRadius: 8, padding: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    erpTable: { width: "100%", borderCollapse: "collapse" },
    erpTh: { background: "#f8fafc", fontSize: 12, fontWeight: 600, padding: "10px", borderBottom: "1px solid #e5e7eb", color: "#1e293b" },
    erpTd: { fontSize: 13, padding: "10px", borderBottom: "1px solid #f1f5f9", color: "#334155" },
    pageTitleBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
    pageTitle: { fontSize: 20, fontWeight: 700, color: '#1e293b' },
    pageSubtitle: { fontSize: 12, color: '#64748b' },
    primaryBtn: { padding: '6px 14px', fontSize: '13px' },
    modalBackdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 },
    modalBackdropHigher: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1060 },
    modal: { background: '#fff', borderRadius: '8px', maxWidth: '1200px', maxHeight: '90vh', display: 'flex', flexDirection: 'column' },
    card: { background: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0' },
    modalHeader: { padding: '12px 20px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    iconBtn: { background: 'transparent', border: 'none', fontSize: '16px', cursor: 'pointer' },
    modalBody: { padding: '20px', overflowY: 'auto' },
    modalFooter: { padding: '12px 20px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', gap: '10px' },
    tabs: { display: 'flex', gap: 5, marginBottom: '15px', flexWrap: 'wrap' }

};

export default AssetMaster;